import { ProjectWizardContext } from 'context/Context';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { getPropertiesForms } from 'redux/propsSlice';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import {
  Col,
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Row,
  Collapse
} from 'react-bootstrap';
import Select from 'react-select';
import { MinusPlusInput } from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/steps/components/inputs/MinusPlusInput';

export const UnitForm = ({ unit, setUnits, unitIndex, touched, errors }) => {
  const currentErrors = errors.units?.[unitIndex] || {};
  const currentTouched = touched.units?.[unitIndex] || {};
  const { data, form, types } = useContext(ProjectWizardContext);
  const dispatch = useDispatch();

  const propertyTypesOptions = [
    { value: 0, label: '-- Selecciona el tipo de propiedad --' },
    ...types.map(prop => ({
      value: prop.propertyType,
      label: prop.name
    }))
  ];

  useEffect(() => {
    if (unit.property_type) dispatch(getPropertiesForms(unit.property_type));
  }, [unit.property_type]);

  return (
    <div className="py-2 px-3">
      <Row className="g-3">
        <Col xs={12} xxl={6}>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Nombre</Form.Label>

                <Field
                  as={Form.Control}
                  placeholder="Nombre"
                  name={`units.[${unitIndex}].name`}
                  isInvalid={currentErrors.name && currentTouched.name}
                />

                <Form.Control.Feedback type="invalid">
                  {currentErrors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Estado</Form.Label>

                <Field
                  as={Form.Select}
                  name={`units.[${unitIndex}].status`}
                  isInvalid={currentErrors.status && currentTouched.status}
                >
                  <option value="">Seleccionar</option>
                  <option value="disponible">Disponible</option>
                  <option value="reservado">Reservado</option>
                  <option value="vendido">Vendido</option>
                </Field>

                <Form.Control.Feedback type="invalid">
                  {currentErrors.status}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12}>
              <label>
                Tipo de Propiedad <span className="text-danger">*</span>{' '}
                <small className="text-muted">
                  (Departamento, Casa, Cochera, ...)
                </small>
              </label>

              <Select
                name={`units.[${unitIndex}].property_type`}
                disabled={data._id}
                options={propertyTypesOptions}
                onChange={selectedOption => {
                  setUnits(prev => {
                    const newUnits = [...prev];
                    newUnits[unitIndex].property_type = selectedOption.value;
                    newUnits[unitIndex].sub_property_type = '0';
                    return newUnits;
                  });
                }}
                value={
                  propertyTypesOptions.find(
                    option => option.value === unit.property_type
                  ) || propertyTypesOptions[0]
                }
                isSearchable={false}
              />

              {currentErrors.property_type && (
                <label style={{ color: '#da1717e8' }}>
                  {currentErrors.property_type}
                </label>
              )}
            </Col>

            <Col
              xs={12}
              className={classNames({
                'mt-0':
                  !form?.subpropertyTypes &&
                  unit.property_type !== 0 &&
                  unit?.sub_property_type !== 0
              })}
            >
              <Collapse
                in={
                  !!form?.subpropertyTypes &&
                  unit.property_type &&
                  unit.property_type !== 0
                }
              >
                <div>
                  <label>
                    Subtipo de Propiedad <span className="text-danger">*</span>
                    <small className="text-Muted"></small>
                  </label>

                  <Field
                    as="select"
                    className="form-select"
                    name={`units.[${unitIndex}].sub_property_type`}
                    disabled={!form?.subpropertyTypes}
                    onChange={e => {
                      if (form?.subpropertyTypes)
                        setUnits(prev => {
                          const newUnits = [...prev];
                          newUnits[unitIndex].sub_property_type =
                            e.target.value;

                          return newUnits;
                        });
                    }}
                  >
                    <option value={0} hidden>
                      -- Seleccione el subtipo de propiedad --
                    </option>

                    {form?.subpropertyTypes?.map(subprop => {
                      return (
                        <option key={subprop.id} value={subprop.id}>
                          {subprop.title}
                        </option>
                      );
                    })}
                  </Field>
                  {currentErrors.sub_property_type && (
                    <label style={{ color: '#da1717e8' }}>
                      {currentErrors.sub_property_type}
                    </label>
                  )}
                </div>
              </Collapse>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Piso</Form.Label>

                <Field
                  as={Form.Control}
                  placeholder="Piso"
                  name={`units.[${unitIndex}].floor`}
                  isInvalid={currentErrors.floor && currentTouched.floor}
                />
              </Form.Group>

              <Form.Control.Feedback type="invalid">
                {currentErrors.floor}
              </Form.Control.Feedback>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Letra / Número</Form.Label>

                <Field
                  as={Form.Control}
                  placeholder="Letra / Número"
                  name={`units.[${unitIndex}].number_letter`}
                  isInvalid={
                    currentErrors.number_letter && currentTouched.number_letter
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {currentErrors.number_letter}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Superficie total</Form.Label>
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
                  <Field
                    as={Form.Control}
                    placeholder="Superficie total"
                    name={`units.[${unitIndex}].total_surface`}
                    isInvalid={
                      currentErrors.total_surface &&
                      currentTouched.total_surface
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    {currentErrors.total_surface}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Superficie cubierta</Form.Label>
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
                  <Field
                    as={Form.Control}
                    placeholder="Superficie cubierta"
                    name={`units.[${unitIndex}].covered_surface`}
                    isInvalid={
                      currentErrors.covered_surface &&
                      currentTouched.covered_surface
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    {currentErrors.covered_surface}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
        </Col>

        <Col xs={12} xxl={6}>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Precio</Form.Label>
                <InputGroup>
                  <DropdownButton
                    variant="secondary"
                    defaultValues={unit?.currency}
                    id="input-group-dropdown-1"
                    menuVariant="dark"
                    title={unit?.currency === 1 ? 'USD' : 'ARS'}
                  >
                    <Dropdown.Item
                      onClick={e =>
                        setUnits(prev => {
                          const newUnits = [...prev];
                          newUnits[unitIndex].currency = parseInt(e.target.id);

                          return newUnits;
                        })
                      }
                      id={1}
                    >
                      USD
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={e =>
                        setUnits(prev => {
                          const newUnits = [...prev];
                          newUnits[unitIndex].currency = parseInt(e.target.id);

                          return newUnits;
                        })
                      }
                      id={2}
                    >
                      ARS
                    </Dropdown.Item>
                  </DropdownButton>

                  <Field
                    as={Form.Control}
                    placeholder="Precio"
                    name={`units.[${unitIndex}].price`}
                    isInvalid={currentErrors.price && currentTouched.price}
                  />

                  <Form.Control.Feedback type="invalid">
                    {currentErrors.price}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Expensas</Form.Label>
                <InputGroup>
                  <DropdownButton
                    variant="secondary"
                    defaultValues={unit?.expenses_currency}
                    id="input-group-dropdown-1"
                    menuVariant="dark"
                    title={unit?.expenses_currency === 1 ? 'USD' : 'ARS'}
                  >
                    <Dropdown.Item
                      onClick={e =>
                        setUnits(prev => {
                          const newUnits = [...prev];
                          newUnits[unitIndex].expenses_currency = parseInt(
                            e.target.id
                          );

                          return newUnits;
                        })
                      }
                      id={1}
                    >
                      USD
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={e =>
                        setUnits(prev => {
                          const newUnits = [...prev];
                          newUnits[unitIndex].expenses_currency = parseInt(
                            e.target.id
                          );

                          return newUnits;
                        })
                      }
                      id={2}
                    >
                      ARS
                    </Dropdown.Item>
                  </DropdownButton>

                  <Field
                    as={Form.Control}
                    placeholder="Expensas"
                    name={`units.[${unitIndex}].expenses`}
                    isInvalid={
                      currentErrors.expenses && currentTouched.expenses
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    {currentErrors.expenses}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={6} md={3}>
              <MinusPlusInput
                noCenter
                title="Ambientes"
                name="ambience"
                quantity={unit?.ambience}
                handleChangeCarac={(e, name, action) => {
                  setUnits(prev => {
                    const newUnits = [...prev];
                    const prevValue = newUnits[unitIndex][name];

                    newUnits[unitIndex][name] =
                      action === 'add' ? prevValue + 1 : prevValue - 1;

                    return newUnits;
                  });
                }}
              />
            </Col>

            <Col xs={6} md={3}>
              <MinusPlusInput
                noCenter
                title="Baños"
                name="bathrooms"
                quantity={unit?.bathrooms}
                handleChangeCarac={(e, name, action) => {
                  setUnits(prev => {
                    const newUnits = [...prev];
                    const prevValue = newUnits[unitIndex][name];

                    newUnits[unitIndex][name] =
                      action === 'add' ? prevValue + 1 : prevValue - 1;

                    return newUnits;
                  });
                }}
              />
            </Col>

            <Col xs={6} md={3}>
              <MinusPlusInput
                noCenter
                title="Toilettes"
                name="toilettes"
                quantity={unit?.toilettes || 0}
                handleChangeCarac={(e, name, action) => {
                  setUnits(prev => {
                    const newUnits = [...prev];
                    const prevValue = newUnits[unitIndex][name] || 0;

                    newUnits[unitIndex][name] =
                      action === 'add' ? prevValue + 1 : prevValue - 1;

                    return newUnits;
                  });
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

UnitForm.propTypes = {
  unit: PropTypes.object,
  setUnits: PropTypes.func,
  unitIndex: PropTypes.number,
  errors: PropTypes.object,
  touched: PropTypes.object
};
